import { useState } from 'react';
import './ConfirmDeleteDialog.css';

function ConfirmDeleteDialog({ entityType, entityName, onConfirm, onCancel }) {
  const [input, setInput] = useState('');
  const matches = input === entityName;

  return (
    <div className="cdd-overlay" onClick={onCancel}>
      <div className="cdd-modal" onClick={e => e.stopPropagation()}>
        <h3 className="cdd-title">Delete {entityType}</h3>
        <p className="cdd-warning">
          This action <strong>cannot be undone</strong>. This will permanently delete
          the {entityType} <strong>"{entityName}"</strong>
          {entityType === 'test cycle' && ' and all its associated test runs'}.
        </p>
        <label className="cdd-label">
          Please type <strong>{entityName}</strong> to confirm:
        </label>
        <input
          className="cdd-input"
          type="text"
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder={entityName}
          autoFocus
        />
        <div className="cdd-actions">
          <button className="cdd-btn-cancel" onClick={onCancel}>Cancel</button>
          <button
            className="cdd-btn-delete"
            disabled={!matches}
            onClick={onConfirm}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteDialog;
